import api from './api';

export interface ContentItem {
  id: string;
  websiteId: string;
  type: 'blog' | 'social' | 'email' | 'promo' | 'faq' | 'testimonial' | 'gallery' | 'website-update';
  title: string;
  content: string;
  scheduledDate: string | null;
  status: 'draft' | 'scheduled' | 'posted';
  platform: string[];
  keywords: string[];
  action: string | null;
  createdAt: string;
  updatedAt: string;
}

export type ContentItemInput = Omit<ContentItem, 'id' | 'createdAt' | 'updatedAt'>;

export const contentPlanService = {
  getItems: async (params?: { status?: string; type?: string; websiteId?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.status) searchParams.append('status', params.status);
    if (params?.type) searchParams.append('type', params.type);
    if (params?.websiteId) searchParams.append('websiteId', params.websiteId);
    const response = await api.get(`/api/content-plan?${searchParams.toString()}`);
    return response.data.data as { items: ContentItem[]; total: number };
  },

  getItem: async (id: string) => {
    const response = await api.get(`/api/content-plan/${id}`);
    return response.data.data as ContentItem;
  },

  createItem: async (data: Partial<ContentItemInput>) => {
    const response = await api.post('/api/content-plan', data);
    return response.data.data as ContentItem;
  },

  updateItem: async (id: string, data: Partial<ContentItemInput>) => {
    const response = await api.patch(`/api/content-plan/${id}`, data);
    return response.data.data as ContentItem;
  },

  deleteItem: async (id: string) => {
    await api.delete(`/api/content-plan/${id}`);
  },
};
